import { render, staticRenderFns } from "./AiRubricBuilderModal.vue?vue&type=template&id=22c8e015&scoped=true"
import script from "./AiRubricBuilderModal.vue?vue&type=script&lang=js"
export * from "./AiRubricBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./AiRubricBuilderModal.vue?vue&type=style&index=0&id=22c8e015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8e015",
  null
  
)

export default component.exports